/* Royal Mist — basic image protection
   Disables right-click context menu and drag-to-save on images sitewide.
   Note: this is a deterrent, not a security measure. It does not and cannot
   block screenshots or camera photos of the screen — no website script can. */
(function () {
  document.addEventListener('contextmenu', function (e) {
    if (e.target && e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  });

  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  });

  function lockImage(img) {
    img.setAttribute('draggable', 'false');
  }
  document.querySelectorAll('img').forEach(lockImage);

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.tagName === 'IMG') lockImage(node);
        node.querySelectorAll && node.querySelectorAll('img').forEach(lockImage);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
